import { TFunction } from 'i18next';

import { EventTypeStrategy, EventTypeCellParts } from "./EventTypeStrategy";
import { getTranslatedEventTypeName } from "../../utils/eventTypeUtils";

import { TransactionType } from "@/types/transaction/TransactionType";

export class DefaultEventTypeStrategy implements EventTypeStrategy {
  renderCell(row: TransactionType, t: TFunction): JSX.Element {
    return <>{t(`eventTypes.${row.eventType}`)}</>;
  }

  getTypeAndDescription(row: TransactionType, t: TFunction): EventTypeCellParts {
    return {
      type: <>{getTranslatedEventTypeName(row.eventType, t)}</>,
      description: <></>
    };
  }
}
